import { Component, OnInit,Input, ViewChild, ElementRef } from '@angular/core';
import Keyboard from 'simple-keyboard';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Device } from '@ionic-native/device/ngx';
import { TouchID } from '@ionic-native/touch-id/ngx';
import { Platform } from '@ionic/angular';
import { AndroidFingerprintAuth } from '@ionic-native/android-fingerprint-auth/ngx';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

  @ViewChild('recaptcha', {static: true }) recaptchaElement: ElementRef;

  // @Input Keyvalues:string='';
  showKeyboard:boolean = false;
  siteKey:string;
  showPassword:boolean = false;
  keyboard: Keyboard;
  userName:string;
  userPass:string;

  pin1;pin2;pin3;pin4;
  mpin:string;

  helloText:any="Good Day";
  isMobile:boolean = false;
  isDesktop:boolean = false;
  isMPINRegistered:boolean = false;
  isFaceIDAvailable:boolean = false;
  isTouchIDAvailable:boolean = false;
  doShowLoginForm:boolean = false;
  doShowUserInfo:boolean = false;

  constructor(
    private router: Router,
    private deviceService:DeviceDetectorService,
    private device: Device,
    private touchId: TouchID,
    private platform: Platform,
    private androidFingerprintAuth: AndroidFingerprintAuth
  ) {
    this.siteKey='6Lek1OYZAAAAAPO3vt4EVB5K5by3k9JdAgtWHyEI';
    this.isMobile = this.deviceService.isMobile();
    this.isDesktop = this.deviceService.isDesktop();

    if(this.isMobile){
      this.platform.ready().then(() => {
        this.checkTouchIDAvailable();
      });
    }
 }

  ngOnInit(): void {
    if(!this.isMPINRegistered) this.doShowLoginForm = true;
    var data = [
      [22, 'Working late'],
      [18, 'Good evening'],
      [12, 'Good afternoon'],
      [5,  'Good morning'],
      [0,  'Whoa, early bird']
    ],
    hr = new Date().getHours();

    for (var i = 0; i < data.length; i++) {
        if (hr >= data[i][0]) {
          this.helloText = data[i][1];
            break;
        }
    }
    
    if(!this.isMobile){
      this.doShowLoginForm = true;
      this.keyboard = new Keyboard({
        onChange: input => this.onChange(input),
        onKeyPress: button => this.onKeyPress(button)
      });
    }
    
  }

  ngAfterViewInit(){
    
  }

  checkTouchIDAvailable(){
    if(this.device.platform.toLowerCase() == 'ios'){
      this.touchId.isAvailable()
      .then(
        res => this.didTouchIDAvailable(res),
        err => console.error('TouchID is not available', err)
      );
    }else if(this.device.platform.toLowerCase() == 'android'){
      this.androidFingerprintAuth.isAvailable()
      .then((result)=> {
        if(result.isAvailable){
          this.didTouchIDAvailable('touch');
        }
      })
      .catch(error => console.error(error));

      window['FingerprintAuth'].isAvailable(function (result) {
        this.didTouchIDAvailable(result);
      }, function(err){
        alert('not available, message: ' + err);
      });
    }
  }

  didTouchIDAvailable(result){
    if(result == "face"){
      this.isFaceIDAvailable = true;
    }else if(result == "touch" || result == "finger" || result == "biometric"){
      this.isTouchIDAvailable = true;
    }else{
      console.log("face id / touch id not available!");
    }
  }

  onChange = (input: string) => {
    this.userPass = input;
    console.log("Input changed", input);
  };

  onKeyPress = (button: string) => {
    console.log("Button pressed", button);
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") this.handleShift();
  };

  handleShift(){
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };

  login(){
    this.router.navigate(['home', 'dashboard']);
  }

  onKey(e){
    let element;
    if (e.code !== 'Backspace')
          element = e.srcElement.nextElementSibling;

      if (e.code === 'Backspace')
          element = e.srcElement.previousElementSibling;

      if(element == null){
        this.mpin = this.pin1 + this.pin2 + this.pin3 + this.pin4;
        console.log(this.mpin);
        this.login();
        return;
      }
      else element.focus();
  }

  showTouchIDAuth(){
    if(this.device.platform.toLocaleLowerCase() == 'ios'){
      this.touchId.verifyFingerprint('Touch your finger on sensor to login.')
      .then(
        res => this.login(),
        err => console.error('Error', err)
      );
    }else if(this.device.platform.toLocaleLowerCase() == 'android'){
      this.androidFingerprintAuth.encrypt({ 
        clientId: "RetailBanking",
        maxAttempts: 5,
        dialogTitle: "Login with touch ID",
        dialogMessage: "Touch your finger on sensor to login."
      })
      .then(res => {
          if (res.withFingerprint) {
              console.log("Successfully encrypted credentials.");
              console.log("Encrypted credentials: " + res.token);
              this.login();
          } else if (res.withBackup) {
            console.log("Successfully authenticated with backup password!");
          } else console.log("Didn't authenticate!");
          this.login();
      })
      .catch(err => {
          if (err === this.androidFingerprintAuth.ERRORS.FINGERPRINT_CANCELLED) {
            console.log("Fingerprint authentication cancelled");
          } else console.error(err);
      });
    }
  }

  toggleLoginForm(){
    this.doShowLoginForm = !this.doShowLoginForm;
  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey' : '6Lek1OYZAAAAAPO3vt4EVB5K5by3k9JdAgtWHyEI',//'6LdxfQoaAAAAAG5JhwgBQyqkScXsw17IABf7dpya ',
      'callback': (response) => {
          console.log(response);
      }
    });
  }

  addRecaptchaScript() {
 
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }
    (function(d, s, id, obj){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
   
  }

}
